module.exports = __webpack_public_path__ + "img/ln3.9353b1d4.png";